/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import ReportsBarChart from "common/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "common/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "common/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { useDispatch, useSelector } from "react-redux";
import DealerHome from "./dealerHome";
import { useEffect } from "react";
import { getCurrentShift } from "store/slice/shiftsSlice";
import ShiftGenerationTable from "layouts/pages/shiftGeneration/ShiftGenerationTable";
import { Accordion, AccordionSummary, AccordionDetails, Button, Typography, Box } from "@mui/material";
import { homeInfoAction } from "store/slice/infoSlice";
import { getNextShift } from "store/slice/shiftsSlice";

function Dashboard() {
  const dispatch = useDispatch();
  const { sales, tasks } = reportsLineChartData;
  const usersStore = useSelector((state) => state.user);
  const infoStore = useSelector(store => store.info);
  const shiftStore = useSelector((state) => state.shift);
  const homeInfo = infoStore?.homeInfo;
  
  useEffect(() => {
    dispatch(getCurrentShift())
    dispatch(getNextShift())
  }, [])

  useEffect(() => {
    if (usersStore?.user?.role != 'dealer') {
      dispatch(homeInfoAction())
    }
  }, [usersStore?.user?.role])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {usersStore?.user?.role === 'dealer'? <DealerHome />: 
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="group"
                title="All Dealers"
                count={homeInfo?.dealersCount}
              />
            </MDBox>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="person_off"
                title="Today's Missing dealers"
                count={homeInfo?.todaysMissingDealers}
              />
            </MDBox>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="error_outline"
                title="Mistakes"
                count={homeInfo?.mistakes}
              />
            </MDBox>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Followers"
                count="+91"
                percentage={{
                  color: "Error",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <Grid mt={5}>
          <Typography variant="h3">Current Shift</Typography>
            <ShiftGenerationTable 
              shifts={shiftStore?.shift?.shifts} 
              creationData={shiftStore?.shift?.creationData} 
              missingDealers={shiftStore?.shift?.missingDealers} 
            />
        </Grid>
        {shiftStore?.nextShift.shifts &&  <Grid mt={5}>
                <Typography variant="h3">Next Shift</Typography>
                <ShiftGenerationTable 
                    shifts={shiftStore?.nextShift?.shifts} 
                    creationData={shiftStore?.nextShift?.creationData} 
                    missingDealers={shiftStore?.nextShift?.missingDealers} 
                />
            </Grid>}
        {/* <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12 }} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item size={{ xs: 12 }} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item size={{ xs: 12 }} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12 }} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item size={{ xs: 12 }} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox> */}
      </MDBox>
      }
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
